module.exports = __webpack_public_path__ + "static/bilikisu-7958b6b5f5c67f8a9bf8b58603215f62.jpg";